import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {AlertService} from '../../_services/index';
import { AdvtService } from '../../_services/advt.service';
import { NotificationsService} from 'angular2-notifications';
import {User} from '../../_models/index';
import {UserService} from '../../_services/index';
import { PusherService } from "../../_services/pusher.service";


@Component({
  moduleId: module.id.toString(),
  templateUrl: 'home.component.html'
})

export class HomeComponent implements OnInit {
  currentUser: User;
  users: any = [];
  logoimage: any;
  dashboarddata: any;
  public options = {
    position: ["top", "right"],
    lastOnBottom: false,
    preventDuplicates: true,
    timeout : 5000
}

  constructor(private userService: UserService,
    private _service: NotificationsService,
    private pusherService: PusherService,
    private alertService: AlertService,
    private _AdvtService: AdvtService) {
    const userInfo = JSON.parse(localStorage.getItem('currentUser'));
    this.currentUser = userInfo.result;

    // if (localStorage.getItem('currentMenu')) {
    //   localStorage.removeItem('currentMenu');
    //   localStorage.setItem('currentMenu', 'home');
    // }

  }

  ngOnInit() {
    this.logoimage = '../../assets/images/logo.png';

    this._AdvtService.getDashboardCount().subscribe(data => {
      if (data.status === 200) {
       
       this.dashboarddata = data.result;
      } else {
       // this.bidPost = false;
      }
    }, error => {
      this.alertService.error(error);
    });
  }

  deleteUser(id: number) {
    this.userService.delete(id).subscribe(() => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/authorized-data/home/home.component.ts